import { ICSSContainer } from './ModalStepper.models';
import styled from '@emotion/styled';
import { theme, media } from '@vfit/shared/themes';

export const Background = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 4;
  background-color: ${theme.colors.text.primary};
`;
/* notes custom px values have been left not to break the design */
export const Container = styled.div<ICSSContainer>`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: ${(props) => (props.withBorderRadius ? '66' : '0')}px;
  border-top-left-radius: ${(props) => (props.withBorderRadius ? '20' : '0')}px;
  border-top-right-radius: ${(props) => (props.withBorderRadius ? '20' : '0')}px;
  background-color: ${theme.colors.text.inverse};
  overflow: hidden;

  ${media.tablet`
    left: 50%;
    top: 50%;
    display: table;
    transform: translate(-50%, -50%);
    width: 62.2%;
    border-radius: ${theme.radius.lg};
  `}

  ${media.desktop`
    left: 50%;
    top: 50%;
    display: table;
    transform: translate(-50%, -50%);
    max-width: 842px;
  `}

  .closing-icon {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    top: 21.5px;
    right: 21.5px;

    ${media.tablet`
      top: 25.5px;
    `}

    ${media.desktop`
      top: 29.5px;
      right: 29.5px;
    `}

    &:hover {
      cursor: pointer;
    }
  }

  .back-icon {
    position: relative;
    display: flex;
    align-items: center;
    top: 8.5px;
    left: 18.75px;
    height: 17px;
    width: 18.75px;

    ${media.tablet`
      top: 10.5px;
    `}

    ${media.desktop`
      top: 14.5px;
      left: 26.75px;
    `}
  }

  .back-icon:hover,
  .closing-icon:hover {
    cursor: pointer;
  }
`;

export const IconsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  background-color: ${theme.colors.text.inverse};
  z-index: 9999;
  width: 100%;
  border-top-left-radius: ${theme.radius.lg};
  border-top-right-radius: ${theme.radius.lg};
  height: ${theme.spacing.xl};

  ${media.tablet`
    height: 38.5px;
  `}

  ${media.desktop`
    height: 42.5px;
  `}
`;

export const ModalContent = styled.div<{
  height?: { tablet: string; desktop: string };
}>`
  max-height: 90vh;
  overflow-y: scroll;
  overflow-x: hidden;
  height: 100%;
  -ms-overflow-style: none; /* for Internet Explorer, Edge */

  ::-webkit-scrollbar {
    display: none; /* for Chrome, Safari, and Opera */
  }

  ${media.withProps.tablet<{ height?: { tablet: string; desktop: string } }>(
    (props) => `
    height: ${props.height?.tablet};
  `,
  )}

  ${media.withProps.desktop<{ height?: { tablet: string; desktop: string } }>(
    (props) => `
    height: ${props.height?.desktop};
  `,
  )}
`;

// TODO: wip FIGMA modal error styles
export const ContainerModalError = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: ${theme.colors.text.inverse};

  ${media.tablet`
    left: 50%;
    top: 50%;
    display: table;
    transform: translate(-50%, -50%);
    width: 62.2%;
  `}

  .closing-icon:hover {
    cursor: pointer;
  }
`;

export const ModalErrorHeader = styled.div`
  display: flex;
  justify-content: space-between;
  padding: ${theme.spacing.lg};
  border-bottom: 1px solid ${theme.colors.border.dark};
`;

export const ModalErrorContent = styled.div`
  display: flex;
  justify-content: space-between;
  padding: ${theme.spacing.xl} ${theme.spacing.lg} ${theme.spacing.lg};
`;

export const ModalErrorFooter = styled.div`
  margin-top: auto;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: ${theme.spacing.lg};

  button {
    text-transform: uppercase;
    max-width: 300px;
  }
`;

